import axios, { AxiosInstance } from 'axios';
import { apiConfig } from '@/config/apiConfig';
import { getVoiceFallbackClient } from './_shared';

// ── Tokens (/api/tokens) ──────────────────────────────────────────────

export type GeneratedToken = { token: string; expires_at?: string };
export type TokenLandingConfig = { campaign_id: string; landing_url: string; recipient?: Record<string, unknown> };

/** `POST /api/tokens/generate` — generate signed token for a recipient. */
export async function generateToken(payload: Record<string, unknown>, axiosInstance?: AxiosInstance): Promise<GeneratedToken> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.post<GeneratedToken>(`${apiConfig.voiceEndpoints.tokens}/generate`, payload);
  return response.data;
}

/** `POST /api/tokens/generate-batch` — generate multiple tokens at once. */
export async function generateTokenBatch(payloads: Record<string, unknown>[], axiosInstance?: AxiosInstance): Promise<GeneratedToken[]> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.post<GeneratedToken[]>(`${apiConfig.voiceEndpoints.tokens}/generate-batch`, { tokens: payloads });
  return Array.isArray(response.data) ? response.data : [];
}

/** `POST /api/tokens/verify` — verify and decode a token. */
export async function verifyToken(token: string, axiosInstance?: AxiosInstance): Promise<{ valid: boolean; payload?: Record<string, unknown> }> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.post<any>(`${apiConfig.voiceEndpoints.tokens}/verify`, { token });
  return response.data;
}

/** `GET /api/tokens/landing/{token}` — resolve token to landing page config. */
export async function fetchTokenLandingConfig(token: string, axiosInstance?: AxiosInstance): Promise<TokenLandingConfig | null> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.get<TokenLandingConfig>(`${apiConfig.voiceEndpoints.tokens}/landing/${token}`);
  return response.data ?? null;
}
